module.exports = __webpack_public_path__ + "static/img/04.54e1072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/04.png
// module id = y623
// module chunks = 0